/* Kilim — tiroir de panier.

   Portage de ../../design/tiroir/tiroir.js. Les quatre points marques [AJAX]
   dans la maquette sont branches : /cart/add.js, /cart/change.js et
   /cart/update.js. L ouverture, le piege de focus et le verrou de defilement
   n ont pas bouge.

   Le total et les prix de ligne ne sont JAMAIS recalcules ici. Apres chaque
   mutation on redemande la section au serveur (Section Rendering API) et on
   remplace le corps et le pied : un panier peut porter une remise automatique
   qu aucun calcul client ne connait.

   Declencheurs attendus dans le reste du theme :
     [data-panier-ouvrir]   — le lien panier de l en-tete
     [data-panier-compte]   — le compteur, partout ou il s affiche
     form[action^="/cart/add"] — le formulaire d achat de la fiche produit
*/

(function () {
  var tiroir = document.querySelector('[data-tiroir]');
  if (!tiroir) return;

  var panneau     = tiroir.querySelector('.tiroir__panneau');
  var urlSection  = tiroir.dataset.urlSection;
  var idSection   = tiroir.dataset.section;
  var declencheur = null;
  var occupe      = false;

  /* ── Ouverture / fermeture ─────────────────────────────────────────────
     Le scroll de la page est bloque, pas masque : masquer la barre decale la
     mise en page de la largeur du scrollbar et fait sauter l en-tete fixe. */
  var scrollY = 0;

  function ouvrir(origine) {
    if (tiroir.hasAttribute('data-ouvert')) return;
    declencheur = origine || document.activeElement;
    /* Les images des suggestions ne se chargent qu a la premiere ouverture :
       fermees, elles concurrencaient l image principale de chaque page. */
    tiroir.setAttribute('data-charge', '');
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    /* Le geste de Cocoon (relevé du 23/09/2026) : le panneau pousse la page
       de sa largeur, par la droite. La largeur est celle qu'il occupera, colonne
       de suggestions comprise quand elle est affichée — mesurée ici, parce
       qu'elle change avec l'écran. */
    var gauche = panneau.getBoundingClientRect().left;
    Array.prototype.forEach.call(tiroir.querySelectorAll('.suggestions'), function (s) {
      var r = s.getBoundingClientRect();
      if (r.width > 0 && r.left < gauche) gauche = r.left;
    });
    var largeur = panneau.getBoundingClientRect().right - gauche;
    document.documentElement.style.setProperty('--poussee', -largeur + 'px');
    document.documentElement.dataset.panneau = 'panier';
    tiroir.setAttribute('data-ouvert', '');
    panneau.focus();
    document.addEventListener('keydown', auClavier);
  }

  function fermer() {
    tiroir.removeAttribute('data-ouvert');
    if (document.documentElement.dataset.panneau === 'panier') {
      delete document.documentElement.dataset.panneau;
    }
    document.removeEventListener('keydown', auClavier);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    if (declencheur && declencheur.focus) declencheur.focus();
  }

  /* Echap ferme, Tab reste dans le panneau. Sans ce piege, la tabulation part
     dans la page derriere le voile, ou plus rien n est visible. */
  function auClavier(e) {
    /* Echap ferme d abord la note, puis le tiroir : sinon on perd sa saisie
       en voulant simplement refermer le champ. */
    if (e.key === 'Escape') {
      var n = tiroir.querySelector('[data-note]');
      if (n && !n.hidden) { noteFermer(); } else { fermer(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var cibles = panneau.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    cibles = Array.prototype.filter.call(cibles, function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!cibles.length) return;
    var premier = cibles[0], dernier = cibles[cibles.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  /* ── Erreurs ───────────────────────────────────────────────────────────── */

  function erreur(message) {
    var zone = tiroir.querySelector('[data-erreur]');
    if (!zone) return;
    zone.textContent = message || '';
    zone.hidden = !message;
  }

  /* ── Rafraichissement depuis le serveur ────────────────────────────────
     On redemande la section rendue et on remplace les deux zones qui portent
     une donnee de panier. Le panneau de note n est pas remplace : il peut
     contenir une saisie en cours. */
  function remplacer(html) {
    var neuf = new DOMParser().parseFromString(html, 'text/html');
    ['[data-tiroir-corps]', '.tiroir__pied'].forEach(function (sel) {
      var a = tiroir.querySelector(sel), b = neuf.querySelector(sel);
      if (a && b) a.replaceWith(b);
    });
    var compte = neuf.querySelector('[data-panier-compte]');
    if (compte) {
      document.querySelectorAll('[data-panier-compte]').forEach(function (n) {
        n.textContent = compte.textContent;
      });
    }
  }

  function rafraichir() {
    return fetch(urlSection, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(remplacer);
  }

  /* UN SEUL ALLER-RETOUR (06/10/2026). La mutation demandait d'abord
     /cart/add.js, PUIS la section : deux requetes en serie avant que le
     tiroir bouge. L'API Ajax rend la section dans la meme reponse quand on
     lui passe `sections` ; on ne retombe sur la seconde requete que si elle
     manque. */
  function appliquer(data) {
    var html = data && data.sections && data.sections[idSection];
    return html ? remplacer(html) : rafraichir();
  }

  function verrouiller(v) {
    occupe = v;
    if (v) { tiroir.setAttribute('data-occupe', ''); }
    else { tiroir.removeAttribute('data-occupe'); }
  }

  /* ── Mutations ─────────────────────────────────────────────────────────── */

  function poster(url, corps) {
    verrouiller(true);
    erreur('');
    if (idSection) { corps.sections = idSection; corps.sections_url = location.pathname; }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corps)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Action impossible.');
          return data;
        });
      })
      .then(appliquer)
      .catch(function (e) { erreur(e.message); })
      .then(function () { verrouiller(false); });
  }

  function ajouter(idVariante, quantite) {
    return poster('/cart/add.js', { items: [{ id: Number(idVariante), quantity: quantite || 1 }] });
  }

  /* ── Delegation ────────────────────────────────────────────────────────── */

  document.addEventListener('click', function (e) {
    var ouvre = e.target.closest('[data-panier-ouvrir]');
    if (ouvre) { e.preventDefault(); ouvrir(ouvre); return; }

    var ajoute = e.target.closest('[data-panier-ajouter]');
    if (ajoute) {
      e.preventDefault();
      if (occupe) return;
      var origine = ajoute;
      ajouter(ajoute.dataset.varianteId, 1).then(function () { ouvrir(origine); });
      return;
    }

    if (!tiroir.contains(e.target)) return;

    if (e.target.closest('[data-tiroir-fermer]')) { fermer(); return; }

    var pas = e.target.closest('[data-qte]');
    if (pas) {
      if (occupe) return;
      var ligne = pas.closest('[data-ligne]');
      var sortie = pas.parentElement.querySelector('[data-qte-valeur]');
      var q = parseInt(sortie.textContent, 10) + parseInt(pas.dataset.qte, 10);
      if (q < 1) return;
      /* Retour optique immediat : le serveur confirme, il ne dicte pas le
         temps de reaction du bouton. */
      sortie.textContent = q;
      poster('/cart/change.js', { id: ligne.dataset.cle, quantity: q });
      return;
    }

    var retire = e.target.closest('[data-retirer]');
    if (retire) {
      if (occupe) return;
      poster('/cart/change.js', { id: retire.closest('[data-ligne]').dataset.cle, quantity: 0 });
    }
  });

  /* La fiche produit poste son formulaire : on l intercepte pour ouvrir le
     tiroir au lieu de quitter la page. Sans JavaScript, le POST part et
     Shopify redirige vers /cart — le parcours reste complet. */
  document.addEventListener('submit', function (e) {
    var forme = e.target;
    if (!forme.action || forme.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    if (occupe) return;
    verrouiller(true);
    erreur('');
    /* Le bouton repond tout de suite : sans signe, l'attente du serveur se
       lisait comme un clic perdu. */
    var envoi = forme.querySelector('[type="submit"]');
    if (envoi) envoi.setAttribute('aria-busy', 'true');
    var corps = new FormData(forme);
    if (idSection) { corps.append('sections', idSection); corps.append('sections_url', location.pathname); }
    /* Le tiroir n'attend plus le serveur (06/10/2026) : l'ajout (300 a 600 ms
       mesures) et l'ouverture s'additionnaient. Mais s'ouvrir dans la meme
       frame que le clic allait trop vite : on ne voyait pas le bouton
       repondre. Il s'ouvre donc 220 ms apres le clic, le temps que le bouton
       s'enfonce, ou des la reponse si elle arrive avant. Pendant l'attente
       le corps est estompe (data-occupe) ; la ligne ajoutee arrive dedans. */
    var parti = false;
    function partir() { if (!parti) { parti = true; ouvrir(envoi); } }
    setTimeout(partir, 220);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: corps })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || 'Ajout impossible.');
          return d;
        });
      })
      .then(appliquer)
      .catch(function (err) { erreur(err.message); })
      .then(function () {
        partir();
        verrouiller(false);
        if (envoi) envoi.removeAttribute('aria-busy');
      });
  });

  /* ── Note de commande ──────────────────────────────────────────────────
     Elle monte du bas et redescend (style.css, .tiroir .note). `hidden` ne
     tombe qu'une fois la descente finie, sinon elle disparaitrait net. */
  function note() { return tiroir.querySelector('[data-note]'); }
  var noteMinuterie = null;

  function noteOuvrir() {
    var n = note(); if (!n) return;
    clearTimeout(noteMinuterie);
    n.hidden = false;
    n.getBoundingClientRect();           // point de depart pose avant le mouvement
    n.setAttribute('data-ouvert', '');
    /* Le focus va au panneau, PAS au champ (06/10/2026) : sur iOS, focaliser
       le champ ouvre le clavier, qui recouvre la note pendant qu'elle monte.
       La cliente touche le champ quand elle veut ecrire. */
    if (!n.hasAttribute('tabindex')) n.setAttribute('tabindex', '-1');
    n.focus({ preventScroll: true });
  }
  function noteFermer() {
    var n = note(); if (!n || !n.hasAttribute('data-ouvert')) return;
    n.removeAttribute('data-ouvert');
    var duree = parseFloat(getComputedStyle(n).transitionDuration) * 1000 || 0;
    noteMinuterie = setTimeout(function () { n.hidden = true; }, duree);
    var d = tiroir.querySelector('[data-note-ouvrir]');
    if (d) d.focus({ preventScroll: true });
  }

  /* Un clic sur le voile (pose sur le panneau, hors de la note) referme. */
  tiroir.addEventListener('click', function (e) {
    var n = note();
    if (n && n.hasAttribute('data-ouvert') && e.target === panneau) noteFermer();
  });

  tiroir.addEventListener('click', function (e) {
    if (e.target.closest('[data-note-ouvrir]')) { noteOuvrir(); return; }
    if (e.target.closest('[data-note-annuler]')) { noteFermer(); return; }
    if (e.target.closest('[data-note-valider]')) {
      var champ = note().querySelector('.note__champ');
      var texte = champ.value.trim();
      poster('/cart/update.js', { note: texte }).then(function () {
        var libelle = tiroir.querySelector('[data-note-libelle]');
        if (libelle) libelle.textContent = texte ? 'Modifier la note' : 'Ajouter une note';
        noteFermer();
      });
    }
  });
})();
